// extracted by mini-css-extract-plugin
module.exports = {"cookieNotificationHolder":"CookieNotification_cookieNotificationHolder__21eDY","linkWrapper":"CookieNotification_linkWrapper__1saKJ"};